// extracted by mini-css-extract-plugin
export default {"section":"legal_section__FRjnW","container":"legal_container__GGv1w","updated":"legal_updated__eoQh8","lead":"legal_lead__S4oad","block":"legal_block__KhwEp"};